import React from "react";

// Pages
import App from "App";

import { createRoot } from "react-dom/client";

import AccountLockedPage from "pages/AccountLockedPage/AccountLockedPage";

// Components
import PermanentLockBoundary from "components/PermanentLockBoundary/PermanentLockBoundary";

// Tools
import { HelmetProvider } from "react-helmet-async";

// Router
import { BrowserRouter } from "react-router-dom";

// Redux
import { Provider } from "react-redux";
import store from "store";

// Get the current subdomain
const currentSubdomain = window.location.hostname.split(".")[0];

// Define conditions to match against the current subdomain
const subdomainConditions = ["identity-dev", "identity-st", "identity-uat"];

// Check if the current subdomain matches any condition
if (subdomainConditions.includes(currentSubdomain)) {
  // Create a new meta tag
  const metaTag = document.createElement("meta");
  metaTag.name = "robots";
  metaTag.content = "noindex";

  // Append the meta tag to the head element
  document.head.appendChild(metaTag);
}

// Get the root element
const container = document.getElementById("root");

// Create a root
const root = createRoot(container);

// Initial render
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <HelmetProvider>
          <PermanentLockBoundary fallBack={<AccountLockedPage />}>
            <App />
          </PermanentLockBoundary>
        </HelmetProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);
